'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regulatory = require('./regulatory');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_regulatory).default;
  }
});

var _model = require('./model');

Object.defineProperty(exports, 'LogoRecordType', {
  enumerable: true,
  get: function get() {
    return _model.LogoRecordType;
  }
});
Object.defineProperty(exports, 'LogosListType', {
  enumerable: true,
  get: function get() {
    return _model.LogosListType;
  }
});
Object.defineProperty(exports, 'RegulatoryRecordType', {
  enumerable: true,
  get: function get() {
    return _model.RegulatoryRecordType;
  }
});
Object.defineProperty(exports, 'RegulatoryRecord', {
  enumerable: true,
  get: function get() {
    return _model.RegulatoryRecord;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/regulatory/index.js
// module id = 457
// module chunks = 0